import LogRequests from "app/api/log";
import { handleGenericApiError } from "app/api/error";
import { addLoading, removeLoading } from "./loading";
import { I18n } from "react-redux-i18n";
import { message } from "antd";
export const ACTION_SAVE_LOGS = "log:ACTION_SAVE_LOGS";
export const ACTION_SAVE_LOGS_DETAILS = "log:ACTION_SAVE_LOGS_DETAILS";

export const fetchSimpleLogs = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await LogRequests.fetchLogs(params);
    dispatch({ type: ACTION_SAVE_LOGS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchDetailsLogs = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await LogRequests.fetchDetailsLogs(params);
    dispatch({ type: ACTION_SAVE_LOGS_DETAILS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchLogsError = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await LogRequests.fetchLogsError(params);
    dispatch({ type: ACTION_SAVE_LOGS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadLogErrorsConsolidated = params => async () => {
  if (
    params.searchParameter?.InitialLogDate &&
    params.searchParameter?.EndLogDate
  ) {
    var initialDate = params.searchParameter?.InitialLogDate.split(" ");
    var endDate = params.searchParameter?.EndLogDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 185) {
      try {
        const response = await LogRequests.downloadLogErrorsConsolidated(
          params.searchParameter
        );
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "consolidados_erros.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};

export const downloadLogs = params => async () => {
  if (
    params.searchParameter?.InitialLogDate &&
    params.searchParameter?.EndLogDate
  ) {
    var initialDate = params.searchParameter?.InitialLogDate.split(" ");
    var endDate = params.searchParameter?.EndLogDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 2) {
      try {
        const response = await LogRequests.downloadLogs(params.searchParameter);
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "logs.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID_LOGS"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};
